import { coreUrls } from '@/api/urls/core';

import * as Helper from '@/utilities/services';

import { RequestResponseType } from '../../../../models';
import { requestOtpBodyParamType, requestOtpResponseType, verifyOtpBodyParamType, verifyOtpResponseType } from './models';

import { api } from '@/api/client';
import { AxiosPromise } from 'axios';

export const requestOtpService = (bodyParam: requestOtpBodyParamType): AxiosPromise<RequestResponseType<requestOtpResponseType>> => {
    const options = Helper.setApiOptions(coreUrls.requestOtp, { bodyParam }, false);
    return api({ ...options, method: 'POST' }, false);
};

export const verifyOtpService = (bodyParam: verifyOtpBodyParamType): AxiosPromise<RequestResponseType<verifyOtpResponseType>> => {
    const options = Helper.setApiOptions(coreUrls.verifyOtp, { bodyParam }, false);
    return api({ ...options, method: 'POST' }, false);
};

export const signOutService = () => {
    const options = Helper.setApiOptions(coreUrls.signOut);
    return api({ ...options, method: 'GET' }, false);
};
